<template>
  <v-card title="Notes">
    <template v-slot:append>
      <v-row>
        <v-col cols="auto">
          <v-switch v-model="showHidden" label="Show Hidden"></v-switch>
        </v-col>
        <v-col cols="auto">
          <v-icon icon="mdi-note-plus" @click="openModal('editNote')"></v-icon>
        </v-col>
      </v-row>
    </template>
    <v-container fluid>
      <v-card-text>
        <v-row>
          <v-col v-for="note in notes" :key="note.id" cols="12">
            <v-card v-if="!note.hide || note.hide == showHidden" :title="note.title">
              <template v-slot:append>
                <v-icon color="primary" @click="openModal('editNote', note)">mdi-pencil</v-icon>
                <v-icon color="red" @click="openModal('removeNote', note)">mdi-delete</v-icon>
              </template>
              <v-card-subtitle
                >Created By: {{ note.created_by?.first_name }} {{ note.created_by?.last_name }}
                <br />
                {{ formatDisplayDate(note.created_on) }}
              </v-card-subtitle>
              <v-card-text>
                <div v-html="note.content"></div>
              </v-card-text>
            </v-card> </v-col
        ></v-row>
        <v-list v-if="notes.length == 0"> There are no notes for this team. </v-list>
      </v-card-text>
      <v-dialog v-model="editNoteModal" max-width="600px">
        <NoteEditCompontent
          :note="currentNote"
          :is-create="isCreate"
          @noteEditCanceled="editNoteModal = false"
          @noteEditComplete="editCompleted"
          @snack="throwSnack"></NoteEditCompontent>
      </v-dialog>
      <ConfirmDeleteComponent
        :description="currentNote.title"
        title="Branch Admin"
        item="note"
        :isOpen="deleteNoteModal"
        @actionCanceled="deleteNoteModal = false"
        @actionConfirmed="removeNote">
      </ConfirmDeleteComponent>
    </v-container>
  </v-card>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue';
import { useNoteStore } from '@/stores/modules/admin';
import { formatDisplayDate } from '@/helpers/dateTools';
import { INoteDTO, NoteDTO } from '@/dtos';
import ConfirmDeleteComponent from '@/components/ui/ConfirmDeleteComponent.vue';
import NoteEditCompontent from '@/components/notes/NoteEditCompontent.vue';
import { useSnack } from '@/helpers';
import { SNACKSTATUS } from '@/stores/util';
const showHidden = ref(true);
const currentNote = ref<INoteDTO>(new NoteDTO());
const editNoteModal = ref(false);
const deleteNoteModal = ref(false);
const isCreate = ref(false);
const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();
const { throwSnack } = useSnack(emit);
// Note Store
const noteStore = useNoteStore();

const notes = computed(() => noteStore.notesQuery.data ?? []);

const openModal = (type: string, item?: INoteDTO) => {
  currentNote.value = new NoteDTO(item);
  if (type === 'editNote') {
    isCreate.value = !item ? true : false;
    editNoteModal.value = true;
  } else if (type === 'removeNote') {
    deleteNoteModal.value = true;
  }
};

const removeNote = async () => {
  await noteStore.remove.mutateAsync(currentNote.value.id);
  deleteNoteModal.value = false;
};

const editCompleted = () => {
  editNoteModal.value = false;
  currentNote.value = new NoteDTO();
};
</script>
